@import '../../styles/checkout-order-details.css';

:host { display: block; }